import { Building } from '@/types';
import Vue from 'vue';
import Vuex, { ActionTree, GetterTree, MutationTree } from 'vuex';

Vue.use(Vuex);

const namespaced = true;

const localState: {} = {};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getters: GetterTree<{}, any> = {
  // Only return buildings which have atleast one catalogue available
  getConditionalBuildings: (_state, _getters, rootState, rootGetters) => () => {
    return rootState.config.buildings.filter((building: Building) => {
      const matchingCatalogues = building.catalogues.filter((catalogue) =>
        rootGetters['user/isCatalogueWithinUserConditions'](
          catalogue.displayConditions
        )
      ).length;
      return !!matchingCatalogues;
    });
  },
};

const mutations: MutationTree<{}> = {};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const actions: ActionTree<{}, any> = {
  GET_BUILDING_DATA: (context): Promise<boolean> => {
    // Get all catalogues
    const promiseArrayCatalogues: Promise<void>[] = [];
    context.rootState.config.buildings.forEach((building: Building) => {
      building.catalogues.forEach((catalogue) => {
        // Check if the catalogue is within the user conditions
        if (
          context.rootGetters['user/isCatalogueWithinUserConditions'](
            catalogue.displayConditions
          )
        ) {
          promiseArrayCatalogues.push(
            context.dispatch(
              'catalogues/GET_CATALOGUE_VIEW',
              catalogue.doceboCatalogueId,
              { root: true }
            )
          );
        }
      });
    });
    // getting enrolments depends on catalogue data being fully loaded,
    // so we must perform the requests in this sequence
    return Promise.all(promiseArrayCatalogues).then(
      () =>
        context.dispatch(
          'enrolments/GET_ENROLMENT_STATUS_FOR_ALL_CATALOGUES',
          null,
          {
            root: true,
          }
        ),
      () => {
        return Promise.reject(
          new Error('failed to get all catalogues and enrolments')
        );
      }
    );
  },
};

export { namespaced, localState as state, getters, mutations, actions };
